import { getEnvVar } from '../envUtils.ts';
import ApiService from "./ApiService";

const getAllGeoFeatures = (missionId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission/${missionId}/areaOfInterests`);
}
const getAllGroundStations = (missionId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}groundstation/${missionId}/allgroundstations`);
}

const getAllSatelliteGroups = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all?missionid=${missionId}&scenarioid=${scenarioId}`);
}
const getGroupsOrbits = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/group/all/orbit?missionid=${missionId}&scenarioid=${scenarioId}`);
}

const deleteSatelliteGroup = (missionId, scenarioId, groupId) => {
    return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/group?missionid=${missionId}&scenarioid=${scenarioId}&groupid=${groupId}`)
}
const editSatelliteGroup = (missionId, scenarioId, groupId, body) => {
    return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/group/${groupId}/edit?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const createSatelliteGroup = (missionId, scenarioId, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/group?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const uploadTle = (missionId, scenarioId, body) => {
    return ApiService.upload(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/tleupload/group?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const renameSatelliteGroup = (missionId, scenarioId, groupId, body) => {
    return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/group/${groupId}/rename?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const duplicateSatelliteGroup = (missionId, scenarioId, groupId) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/group/${groupId}/clone?missionid=${missionId}&scenarioid=${scenarioId}`)
}
const updateSatelliteSwathConfig = (missionId, scenarioId, groupId, sateId, body) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/singleSatelliteConfig?missionid=${missionId}&scenarioid=${scenarioId}&satid=${sateId}`, body)
}
const updateGroupSwathConfig = (missionId, scenarioId, groupId, body) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/update-config?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const updateSelectedGroups = (missionId, scenarioId, body) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all/update-config?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const deleteSelectedGroups = (missionId, scenarioId, body) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const createGroundStation = (name, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}groundstation?groundStationName=${name}`, body)
}
const updateGroundStation = (body) => {
    return ApiService.put(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}groundstation/gs-update`, body)
}
const renameGroundStation = (groundStationId, groundStationName) => {
    return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}groundstation/gs-update/${groundStationId}/rename?groundStationName=${groundStationName}`)
}

const deleteGroundStation = (groundStationId) => {
    return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}groundstation?groundStationId=${groundStationId}`)
}

const createFeature = (missionId, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission/${missionId}/areaOfInterests`, body)
}

const renameFeature = (featureId, name) => {
    return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission/areaOfInterest/${featureId}/rename?areaOfInterestName=${name}`)
}

const deleteFeature = (featureId) => {
    return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission/areaOfInterest/${featureId}`)
}

const coverageAnalysis = (missionId, scenarioId, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/analysis/coverage?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const groundLinkAnalysis = (missionId, scenarioId, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/analysis/ground-link-optimiser?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const contactAnalysis = (missionId, scenarioId, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/analysis/groundstation?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}
const getCoverageReportStatus = (coverageAnalysisId, missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/analysis/${coverageAnalysisId}/coverage-status?missionid=${missionId}&scenarioid=${scenarioId}`)
}
const getGroundLinkReportStatus = (groundLinkAnalysisId, missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/analysis/${groundLinkAnalysisId}/ground-link-optimiser-status?missionid=${missionId}&scenarioid=${scenarioId}`)
}
const getCoverageReports = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/allReports/coverage?missionid=${missionId}&scenarioid=${scenarioId}`)
}
const getContactReports = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/allReports/groundstation?missionid=${missionId}&scenarioid=${scenarioId}`)
}
const getGroundLinkReports = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/allReports/ground-link-optimiser?missionid=${missionId}&scenarioid=${scenarioId}`)
}

const getPropultionReports = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/${missionId}/scenario/${scenarioId}/analysis/station-keeping`)
}

const deleteReport = (missionId, scenarioId, reportId, type) => {
    if (type === 'Coverage') {
        return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/report/${reportId}/coverage?missionid=${missionId}&scenarioid=${scenarioId}`)
    } else if (type === 'GroundLink') {
        return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/report/${reportId}/ground-link-optimiser?missionid=${missionId}&scenarioid=${scenarioId}`)
    } else if (type === 'Propulsion') {
        return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/${missionId}/scenario/${scenarioId}/analysis/station-keeping?reportid=${reportId}`)
    } else {
        return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/report/${reportId}/groundstation?missionid=${missionId}&scenarioid=${scenarioId}`)
    }
}

const addThruster = (satId, missionId, scenarioId, body) => {
    return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/satellite/${satId}/thruster?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const deleteThruster = (satId, missionId, scenarioId, thrusterId) => {
    return ApiService.delete(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/satellite/${satId}/thruster?missionid=${missionId}&scenarioid=${scenarioId}&thrusterid=${thrusterId}`)
}

const propulsionBudgetAnalysis = (satId, missionId, scenarioId, body) => {
    return ApiService.post(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/${missionId}/scenario/${scenarioId}/analysis/station-keeping?satelliteid=${satId}`, body)
}

const renameReport = (missionId, scenarioId, reportComponent, reportId, body) => {
    switch (reportComponent) {
        case 'CoverageAnalysis':
            return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/report/${reportId}/coverage/rename?missionid=${missionId}&scenarioid=${scenarioId}`, body)
        case 'GroundStationAnalysis':
            return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/report/${reportId}/groundstation/rename?missionid=${missionId}&scenarioid=${scenarioId}`, body)
        case 'GroundLinkAnalysis':
            return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/report/${reportId}/ground-link-optimiser/rename?missionid=${missionId}&scenarioid=${scenarioId}`, body)
        case 'PropulsionBudget':
            return ApiService.patch(`${getEnvVar("REACT_APP_BACKEND_BASE_URL")}mission-simulation/${missionId}/scenario/${scenarioId}/report/${reportId}/station-keeping/rename`, body)
    }
}

const MissionModelService = {
    getGroupsOrbits,
    getAllGroundStations,
    getAllGeoFeatures,
    getAllSatelliteGroups,
    editSatelliteGroup,
    deleteSatelliteGroup,
    uploadTle,
    createSatelliteGroup,
    renameSatelliteGroup,
    duplicateSatelliteGroup,
    updateGroupSwathConfig,
    updateSelectedGroups,
    deleteSelectedGroups,
    updateSatelliteSwathConfig,
    createGroundStation,
    updateGroundStation,
    renameGroundStation,
    deleteGroundStation,
    createFeature,
    renameFeature,
    deleteFeature,
    coverageAnalysis,
    contactAnalysis,
    groundLinkAnalysis,
    getCoverageReportStatus,
    getGroundLinkReportStatus,
    getCoverageReports,
    getContactReports,
    getGroundLinkReports,
    getPropultionReports,
    deleteReport,
    addThruster,
    deleteThruster,
    propulsionBudgetAnalysis,
    renameReport
}

export default MissionModelService;